const BANNER_TYPES = {
  CAMPAIGN_BANNER_2: 'campaign_banner_2'
};

export const UNACADEMY_CENTRES = 'Unacademy Centres';

export default BANNER_TYPES;
